import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { httpService } from '../../../services/http.service';
import { useStore } from '../../../store';
import { GET_FORM_DATA_URL_MAP, URL_PARAMS } from '../consts';

interface IProps {
    formId: string;
}
export const useGetFormAsset = ({ formId }: IProps) => {
  const { formType } = useParams();
  const { customerId } = useStore(state => state.user);
  const dynamicUrl = GET_FORM_DATA_URL_MAP[formType as keyof typeof GET_FORM_DATA_URL_MAP];
  const formattedUrl = dynamicUrl
    .replace(URL_PARAMS.customerId, customerId)
    .replace(URL_PARAMS.formId, formId);
  return useQuery(
    'GetFormAsset',
    async () => {
      const res = await httpService.get(formattedUrl, { responseType: 'blob' });
      const blob = res.data;
      return URL.createObjectURL(blob);
    },
    {
      enabled: false, cacheTime: 0, refetchOnWindowFocus: false, staleTime: 0,
    },
  );
};
